module.exports = __webpack_public_path__ + "img/upperhand_mob.png";